<template>
  <aside
    v-if="user"
    class="sidebar sidebar-left"
  >
    <div class="sidebar-profile">
      <div class="avatar">
        <v-skeleton-loader
        type="list-item-two-line"
        :loading="!menu"
        transition="scale-transition"
        dark
        >
        <v-img :aspect-ratio="4/3" max-height="300" max-width="300" contain :src="logo" />
        </v-skeleton-loader>
      </div>
      <div class="profile-body dropdown">
        <a><h4> {{ title }} </h4></a>
        <a
          href="#"
          aria-expanded="false"
        ><h4>{{ user.name }}<span class="caret" /></h4></a>
      </div>
    </div>
    <nav>
      <v-skeleton-loader
        type="list-item-two-line"
        :loading="!menu"
        transition="scale-transition"
        dark
      >
        <sidebar-menu
          :class="sidebarColor"
          :menu="menu"
          width="240px"
          :relative="true"
          :hide-toggle="true"
        />
      </v-skeleton-loader>
    </nav>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    appName: window.config.appName,
    opened: false,
    dialog: false,
    menu: null,
    type: 'A',
    logo: '',
    title: '',
  }),

  computed: mapGetters({
    user: 'auth/user',
    permissions: 'auth/permissions',
    params: 'auth/params',
    sidebarColor: 'theme/sidebarColor',
  }),

  watch: {
    user: {
      handler() {
        this.init();
      },
      deep: true,
    },
  },

  async mounted() {
    await this.$store.dispatch('auth/fetchParams');
    this.init();
  },

  methods: {
    async logout() {
      this.dialog = false;
      // Log out the user.
      await this.$store.dispatch('auth/logout');

      // Redirect to login.
      this.$router.push({ name: 'login' });
    },

    init() {
      this.logo = this.params[0];
      this.title = this.params[1];
      if (this.user) {
        window.axios.get(`/api/permissions/${this.type}`)
        .then((result) => {
          let nombreMenu = result.data.map((item) => {
            if (!item.child) {
              if (this.permissions.filter((permission) => permission.name === item.url).length > 0) {
                 item.icon = { class: item.icon, attributes: { title: item.title } };
                return item;
              }
              return null;
            }
            if (this.permissions.filter((permission) => permission.name === item.url).length > 0) {
              let childs = item.child.map((child) => {
                if (this.permissions.filter((permission) => permission.name === child.url).length > 0) {
                  child.icon = { class: child.icon, attributes: { title: child.title } };
                  return child;
                }
                return null;
              });
              delete item.child;
              childs = childs.filter((child) => child != null);
              item.child = childs;
              item.icon = { class: item.icon, attributes: { title: item.title } };
              return item;
            }
            return null;
          });
          nombreMenu = nombreMenu.filter((menu) => menu != null);
          this.menu = nombreMenu;
        });
      }
    },
  },
};
</script>
<style>
  .v-sidebar-menu .vsm--link_level-2 .vsm--icon{
    height: 30px;
    line-height: 30px;
    width: 30px;
  }
  .v-sidebar-menu .vsm--link_level-1 {
    padding: 5px !important;
  }
  .v-sidebar-menu .vsm--link_level-2 {
    padding: 5px !important;
  }
</style>
